exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".serviceRepairView[data-v-7b4084ec] td{color:black}\n", ""]);

